import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';

import {
  LotSource,
  LotTypeEnum,
  UserLotQuery,
} from '../../graphql/service/graphql-auto-main-service';
import { LotNegotiationsPriceFormModalComponent } from './components/lot-negotiations-price-form-modal/lot-negotiations-price-form-modal.component';

@Component({
  selector: 'app-lot-negotiations-price-button',
  templateUrl: './lot-negotiations-price-button.component.html',
  styleUrls: ['./lot-negotiations-price-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotNegotiationsPriceButtonComponent {
  @Input() savedLot: UserLotQuery['lot'];
  @Input() lotId: string;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input() fullSize = false;
  @Output() actionCompleted = new EventEmitter<void>();

  constructor(
    private readonly translate: TranslateService,
    private readonly modalService: NzModalService,
  ) {}

  openLotNegotiationsPriceFormModal(): void {
    this.modalService.create({
      nzTitle: this.translate.instant('NEGOTIATIONS.START_PRICE'),
      nzContent: LotNegotiationsPriceFormModalComponent,
      nzWidth: this.fullSize ? '95%' : '520px',
      nzClosable: false,
      nzMaskClosable: false,
      nzKeyboard: false,
      nzComponentParams: {
        savedLot: this.savedLot,
        lotId: this.lotId,
        lotType: this.lotType,
        lotSource: this.lotSource,
        actionCompleted: this.actionCompleted,
      },
    });
  }
}
